import { Component, Input, Output, EventEmitter, HostListener, Inject, Injector } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { MatDialog } from '@angular/material/dialog';
import { ModalTakePhotosComponent } from '../modal-take-photos/modal-take-photos.component';
import { BuroService } from 'src/app/services/buro.service'
import { Subscription } from 'rxjs';
import { SseService } from 'src/app/services/sse.service';
import { ModalService } from 'src/app/services/modal-service.service';
import { Icons } from 'src/app/components/modal-alert/enums';
import { returnFileSize, _isNullOrUndefined, removeAccents } from '../../helpers/code-helper';
import { environment } from 'src/environments/environment';
import { WINDOW } from 'src/app/utils/window';
import { DataService } from 'src/app/services/data.service';
import { KeyclockProfile } from 'src/app/model/http/keyclock.model';
import { KeycloakService } from 'keycloak-angular';
import { StepService } from '../../services/step.service';


export interface FileUploadE {
  error: false,
  msg: '',
  name: ''
}

@Component({
  selector: 'app-btn-upload-files',
  templateUrl: './btn-upload-files.component.html',
  styleUrls: ['./btn-upload-files.component.scss']
})
export class BtnUploadFilesComponent {
  @Output() public generateQr = new EventEmitter();
  @Output() public listenSse = new EventEmitter();
  @Output() errorUploadE = new EventEmitter<boolean>();
  @Input() selectFiles!: any;
  @Input() typeFile!: any;
  public screenWidth: any = this.window.innerWidth;
  public screenHeight: any = this.window.innerHeight;
  obsSse!: Subscription;
  errorMaxSize: boolean = false
  errorDelete: boolean = false
  errorFileAllowed: boolean = false
  errorFileUpload: FileUploadE = {} as FileUploadE;
  userObject!: KeyclockProfile;
  keycloackService: KeycloakService;

  templateSuffix = environment.templateSuffix;
  private dataService: DataService;
  private modalService: ModalService;
  private stepService: StepService;



  constructor(
    private platform: Platform,
    public dialog: MatDialog,
    private buroService: BuroService,
    private sseService: SseService,
    private injector: Injector,
    @Inject(WINDOW) private window: Window
  ) {
    this.modalService = this.injector.get<ModalService>(ModalService);
    this.dataService = this.injector.get<DataService>(DataService);
    this.keycloackService = this.injector.get<KeycloakService>(KeycloakService);
    this.stepService = this.injector.get<StepService>(StepService);
    this.loadUserinfo();
  }

  /**
   * Carga la información del usuario logueado
   * Se utoliza el Nombre y Apellido para preformatear el nombre del documento
   * @memberof BtnUploadFilesComponent
   * @author victor.mendez
   */
  loadUserinfo() {
    this.keycloackService.loadUserProfile().then((user: KeyclockProfile) => {
      this.userObject = user;
    });
  }


  changeVoucher(event: any, item: any) {
    this.uploadFile(item, event.target.files[0]);
    this.dataService.getSharedFunction().subscribe((data: boolean) => {
      if (data) {
        this.errorFileUpload = {} as FileUploadE;
      }
    });
  }

  uploadFile(item: any, doc: File) {
    let file: File;
    this.errorMaxSize = false
    this.errorFileAllowed = false
    let size = returnFileSize(doc.size);
    let fileAllowed = this.validateFileType(doc.type, item.filesAccept || null);

    if (size && fileAllowed) {

      const _name = doc.name.split('.');
      const _namedoc = this.getNameDocument(_name, item.referenceId, item.description, item.documentId);

      file = new File([doc], _namedoc, { type: doc.type });

      item.loader = true;
      item.name = file.name;
      item.size = size;
      let formData = new FormData();
      formData.append('file', file);
      formData.append('size', size);
      formData.append('templateId', item.templateId);
      formData.append('documentId', item.documentId);
      formData.append('clientid', item.clientId);
      formData.append('email', item.email);
      formData.append('sseId', item.sseId);
      formData.append('referenceId', item.referenceId);

      this.buroService.uploadDocuments(formData).subscribe({
        next: (data) => {
          let newd = JSON.parse(data);
          this.errorFileUpload.error = newd.error;
          this.errorFileUpload.msg = newd.message;
          this.errorFileUpload.name = newd.fileName;
          this.selectFiles.files.filter((a: any, index: any) => {
            if (a.name === newd.fileName && newd.error) {
              this.selectFiles.files[index].name = '';
            }
          });

          this.errorUploadE.emit(this.errorFileUpload.error);
          item.loader = false;
        },
        error: (res: any) => {
          console.log(res);
          item.loader = false;
          item.name = null;
          item.size = null;
          this.sseService.destroy();
        }
      });

    } else {
      if (!size)
        this.errorMaxSize = true
      if (!fileAllowed)
        this.errorFileAllowed = true
    }
  }

  /**
   * Genera el nombre del documento a subir ya preformateados con 
   * nombre, apellido y tipo de documento y tambien el referenciaId para verificar si es quincenal o mensual
   * @param {string[]} name El nombre original del archivo
   * @param {string} referenceId El id de referencia del documento servira para verificar si es quincenal o mensual
   * @param {string} description Solo se usa para verificar si el documento es de cuenta o impuestos
   * @param {string} documentId El id del documento para verificar el tipo de documento y contruir el nombre
   * @access private
   * @return {*}  {string}
   * @memberof BtnUploadFilesComponent
   * @author victor.mendez            
   */
  private getNameDocument(name: string[], referenceId: string, description: string, documentId: number): string {

    const formatName = (name: string | null | undefined): string => {
      return _isNullOrUndefined(name) ? '' : removeAccents(name!).trim().split(' ')[0].toLowerCase();
    };

    let firstname = formatName(this.stepService.data.client.firstNamePF);
    let lastname = formatName(this.stepService.data.client.lastNamePF);
    let typeDocument = this.getTypeDocumentName(documentId);
    let extension = name[name.length - 1];

    let isSpecialNaming = referenceId.includes('quincenales') ||
      referenceId.includes('mensuales') ||
      description.toLowerCase().includes('cuenta') ||
      description.toLowerCase().includes('impuestos');
    // Construcye el nombre del documento basado en al condicion
    let documentName = `${firstname}_${lastname}_${typeDocument}`;
    if (isSpecialNaming) {
      documentName += `-${referenceId}`;
    }
    documentName += `.${extension}`;
    return documentName;
  }


  /**
   * Obtiene el nombre del tipo de documento a subir
   * Devolvera una cadena para preformatear el nombre del documento y especificarlo.
   * @param {string} documentId
   * @access private
   * @return {*}  {string} Devuelve el nombre del tipo de documento como prefijo
   * @memberof BtnUploadFilesComponent
   * @author victor.mendez
   */
  private getTypeDocumentName(documentId: number): string {
    const documentTypes: { [id: number]: string } = {
      45198: 'recibo_nomina',
      20108: 'comprobante_domicilio',
      45200: 'estado_cuenta',
      47395: 'declaracion_impuestos',
      51973: 'const_situacion_fiscal',
      47394: 'ultimo_edo_cuenta',
    };
    return documentTypes[documentId] || '';
  }

  /**
   * Muestra el nombre del documento sin la referencia al usuario final en el front
   * @param {string} name
   * @return {*}  {string}
   * @memberof BtnUploadFilesComponent
   * @author victor.mendez
   */
  showNameDocument(name: string): string {
    const keywords = ['quincenales', 'mensuales', 'cuenta', 'impuestos'];
    if (keywords.some(keyword => name.includes(keyword))) {
      const arre = name.split('_');
      arre.splice(arre.length - 2, 1);
      return arre.join('_');
    } else {
      return name;
    }
  }


  deleteVoucher(item: any) {
    const dialogLogin = this.modalService.openAlert({
      title: null,
      content: `El archivo ${this.showNameDocument(item.name)} será eliminado. ¿Deseas continuar?`,
      btnAction1: 'Sí, continuar',
      btnAction2: 'Cancelar',
      icon: Icons.info,
      idBtnAction1: null,
      idBtnAction2: null
    },
      false
    );
    dialogLogin.afterClosed().subscribe((result) => {
      if (result === true) {
        item.loader = true;
        this.buroService.deleteDocuments(item.folderId, item.fileId).subscribe({
          next: () => {
            item.name = null;
            item.size = null;
            item.fileId = '';
            item.folderId = '';
            item.loader = false;
          },
          error: () => {
            this.errorDelete = true;
            item.loader = false;
            setTimeout(() => {
              this.errorDelete = false;
            }, 2000);
          }
        });
      }
    });
  }

  checkshowBtnUpload(index: number) {
    if (index === 0)
      return true;
    else if (this.selectFiles.files[index - 1].name)
      return true
    else
      return false
  }

  openCamera(item: any) {
    const dialogRef = this.dialog.open(ModalTakePhotosComponent, {
      data: {
        item,
        typeFile: this.typeFile
      },
      panelClass: 'takephotos-modalbox',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result)
        this.uploadFile(item, result);
    });
  }

  isMobile() {
    return this.screenWidth < 768 || this.platform.ANDROID || this.platform.IOS
  }

  takePhoto(item: object) {
    this.generateQr.emit({ ...item, typeFile: this.typeFile });
  }

  returnFilesAcept(item: any) {
    return item.filesAccept ? `.${item.filesAccept}` : '.pdf';
  }

  validateFileType(uploadedTypeFile: string, allowedType: string | null) {
    if (allowedType) {
      if (uploadedTypeFile.includes(allowedType))
        return true;
      else
        return false;
    } else {
      if (uploadedTypeFile.includes('pdf')) {
        return true;
      } else {
        return false;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    this.screenWidth = this.window.innerWidth;
    this.screenHeight = this.window.innerHeight;
    this.isMobile();
  }

}
